<div class="w-full bg-gray-50 min-h-screen">
  <!-- Header/Breadcrumb Section -->
  <div class="bg-white border-b border-gray-200 px-6 py-5  top-0  shadow-sm">
    <div class="max-w-[1400px] mx-auto">
      <div class="flex items-center gap-3 mb-3">
        <p-breadcrumb [home]="{icon: 'pi pi-home', routerLink: '/'}" [model]="breadcrumbItems"
          styleClass="border-0 p-0" />
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="max-w-[1400px] mx-auto px-6 py-6">
    <div class="space-y-6">
      <p-skeleton width="100%" height="200px" />
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div class="lg:col-span-2 space-y-6">
          <p-skeleton width="100%" height="300px" />
          <p-skeleton width="100%" height="200px" />
        </div>
        <div class="space-y-6">
          <p-skeleton width="100%" height="250px" />
          <p-skeleton width="100%" height="200px" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading" class="max-w-[1400px] mx-auto px-6 py-6">
    <div *ngIf="synergy">
      <div
        class="bg-white rounded-lg border border-gray-200 mb-6 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
        <div class="h-1" [style.background-color]="getCategoryColor(synergy.category)"></div>

        <div class="p-8">
          <div class="flex flex-col lg:flex-row lg:items-start gap-6">
            <!-- Category Icon -->
            <div class="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
              [style.background-color]="getCategoryColor(synergy.category) + '15'">
              <i [class]="getCategoryIcon(synergy.category)" [style.color]="getCategoryColor(synergy.category)"
                class="text-3xl"></i>
            </div>

            <!-- Title & Meta -->
            <div class="flex-1 min-w-0">
              <div class="flex flex-wrap items-start justify-between gap-4 mb-4">
                <div>
                  <h1 class="text-3xl font-bold text-gray-900 mb-3">{{ synergy.title }}</h1>
                  <div class="flex items-center gap-3 flex-wrap">
                    <p-tag [value]="synergy.category"
                      [style]="{'background-color': getCategoryColor(synergy.category) + '15', 'color': getCategoryColor(synergy.category)}"
                      styleClass="text-xs font-semibold px-3 py-1.5" />
                    <p-tag [value]="getStatusLabel(synergy.status)" [severity]="getStatusSeverity(synergy.status)"
                      styleClass="text-xs font-semibold px-3 py-1.5" />
                  </div>
                </div>
              </div>
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="flex items-center gap-2 mb-2">
                  <i class="pi pi-chart-line text-emerald-600"></i>
                  <span class="text-xs font-semibold text-gray-600 uppercase tracking-wider">Match Score</span>
                </div>
                <div class="text-3xl font-bold text-emerald-600 mb-2">{{ synergy.match_score }}%</div>
                <div class="bg-gray-200 rounded-full h-2 overflow-hidden">
                  <div class="bg-emerald-500 h-full transition-all duration-500" [style.width.%]="synergy.match_score">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Grid -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <!-- Left Column - Main Info -->
        <div class="lg:col-span-2 space-y-6">
          <!-- Partner Information -->
          <div
            class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-gray-50 to-blue-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-building text-blue-600"></i>
                Kooperationspartner
              </h2>
            </div>
            <div class="p-6">
              <div class="flex items-center gap-4">
                <div class="relative">
                  <div class="w-16 h-16 rounded-2xl overflow-hidden ">
                    <img *ngIf="synergy.partner_hub.avatar" [src]="synergy.partner_hub.avatar" alt="Partner"
                      class="w-full h-full object-cover z-0">
                    <div *ngIf="!synergy.partner_hub.avatar"
                      class="w-full h-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
                      <i class="pi pi-building text-white text-2xl"></i>
                    </div>
                  </div>
                </div>
                <div class="flex-1">
                  <h3 class="text-xl font-bold text-gray-900 mb-2">{{ synergy.partner_hub.name }}</h3>
                  <div class="flex items-center gap-4 text-sm text-gray-600">
                    <span class="flex items-center gap-1.5">
                      <i class="pi pi-map-marker text-blue-600"></i>
                      {{ synergy.partner_hub.city }}
                    </span>
                    <span class="flex items-center gap-1.5">
                      <i class="pi pi-tag text-blue-600"></i>
                      {{ synergy.partner_hub.type }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- AI Reasoning -->
          <div
            class="bg-white rounded-xl border border-purple-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-purple-50 via-blue-50 to-indigo-50 border-b border-purple-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-sparkles text-purple-600"></i>
                KI-Analyse
                <span class="text-xs font-semibold px-2 py-1 bg-purple-100 text-purple-700 rounded-full ml-auto">
                  Automatisch generiert
                </span>
              </h2>
            </div>
            <div class="p-6">
              <p class="text-sm text-gray-700 leading-relaxed">{{ synergy.ai_reasoning }}</p>
            </div>
          </div>
          <div
            class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-emerald-50 to-teal-50 border-b border-emerald-100 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-gift text-emerald-600"></i>
                Deine Vorteile
              </h2>
            </div>
            <div class="p-6">
              <div class="space-y-4">
                <div *ngFor="let benefit of synergy.potential_benefits; let i = index"
                  class="flex items-start gap-4 p-3 rounded-lg hover:bg-emerald-50 transition-colors group">
                  <div
                    class="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-200 group-hover:scale-110 transition-all">
                    <i class="pi pi-check text-emerald-600 text-sm font-bold"></i>
                  </div>
                  <p class="text-sm text-gray-700 leading-relaxed flex-1 pt-1">{{ benefit }}</p>
                </div>
              </div>
            </div>
          </div>



          <!-- Timeline Section -->
          <div *ngIf="timeline.length > 0"
            class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-gray-50 to-blue-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-history text-blue-600"></i>
                Aktivitäts-Timeline
              </h2>
            </div>
            <div class="p-6">
              <div class="space-y-4">
                <div *ngFor="let event of timeline"
                  class="flex items-start gap-4 p-4 rounded-lg border transition-all hover:shadow-sm"
                  [class.bg-blue-50]="event.event_type === 'post'" [class.border-blue-200]="event.event_type === 'post'"
                  [class.bg-gray-50]="event.event_type !== 'post'"
                  [class.border-gray-200]="event.event_type !== 'post'">

                  <!-- Icon -->
                  <div class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                    [style.background-color]="getEventColor(event.event_type) + '20'">
                    <i [class]="getEventIcon(event.event_type)" [style.color]="getEventColor(event.event_type)"
                      class="text-lg"></i>
                  </div>

                  <!-- Content -->
                  <div class="flex-1 min-w-0">
                    <div class="flex items-start justify-between gap-2 mb-2">
                      <h4 class="text-sm font-bold text-gray-900">{{ event.title }}</h4>
                      <span class="text-xs text-gray-500 whitespace-nowrap">
                        {{ event.created_at | date:'dd.MM.yyyy HH:mm' }}
                      </span>
                    </div>

                    <p *ngIf="event.description" class="text-sm text-gray-700 leading-relaxed">
                      {{ event.description }}
                    </p>

                    <!-- Author Info (nur bei Posts) -->
                    <div *ngIf="event.event_type === 'post' && event.created_by_hub_name"
                      class="mt-2 flex items-center gap-2">
                      <i class="pi pi-user text-blue-600 text-xs"></i>
                      <span class="text-xs font-medium text-blue-700">
                        von {{ event.created_by_hub_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column - Sidebar -->
        <div class="space-y-6">
          <!-- Confirmation Status -->
          <div
            class="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl px-5 py-4 min-w-[280px]">
            <div class="flex items-center justify-between gap-4">
              <div class="flex-1">
                <div class="text-xs font-semibold text-blue-700 uppercase tracking-wider mb-1.5">
                  Dein Join-Code
                </div>
                <div class="font-mono text-2xl font-bold text-blue-900 tracking-[0.2em] select-all">
                  {{ join_code || 'ABC-DEF-GHI' }}
                </div>
              </div>
              <button type="button" (click)="copyJoinCode()"
                class="w-11 h-11 rounded-lg bg-white hover:bg-blue-100 border-2 border-blue-300 hover:border-blue-400 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow flex-shrink-0 group"
                pTooltip="Join-Code kopieren" tooltipPosition="bottom">
                <i class="pi text-blue-600 text-lg transition-all duration-200" [class.pi-copy]="!codeCopied"
                  [class.pi-check]="codeCopied"></i>
              </button>
            </div>
            <div class="mt-2 pt-2 border-t border-blue-200">
              <p class="text-xs text-blue-700 flex items-center gap-1.5">
                <i class="pi pi-info-circle text-[10px]"></i>
                <span>Teile diesen Code mit Partnern für die Bestätigung</span>
              </p>
            </div>
          </div>
          <div
            class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gray-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-shield-check text-emerald-600"></i>
                Bestätigungsstatus
              </h2>
            </div>
            <div class="p-6 space-y-4">
              <!-- My Confirmation -->
              <div class="rounded-lg p-4 border transition-all" [class.bg-emerald-50]="synergy.my_confirmed"
                [class.border-emerald-200]="synergy.my_confirmed" [class.bg-gray-50]="!synergy.my_confirmed"
                [class.border-gray-200]="!synergy.my_confirmed">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                    [style.background-color]="synergy.my_confirmed ? '#10b981' : '#d1d5db'">
                    <i class="pi text-white" [class.pi-check]="synergy.my_confirmed"
                      [class.pi-clock]="!synergy.my_confirmed"></i>
                  </div>
                  <div class="flex-1">
                    <div class="text-sm font-bold text-gray-900">Meine Bestätigung</div>
                    <div class="text-xs font-medium" [class.text-emerald-600]="synergy.my_confirmed"
                      [class.text-gray-500]="!synergy.my_confirmed">
                      {{ synergy.my_confirmed ? '✓ Bestätigt' : 'Ausstehend' }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Partner Confirmation -->
              <div class="rounded-lg p-4 border transition-all" [class.bg-emerald-50]="synergy.partner_confirmed"
                [class.border-emerald-200]="synergy.partner_confirmed" [class.bg-gray-50]="!synergy.partner_confirmed"
                [class.border-gray-200]="!synergy.partner_confirmed">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                    [style.background-color]="synergy.partner_confirmed ? '#10b981' : '#d1d5db'">
                    <i class="pi text-white" [class.pi-check]="synergy.partner_confirmed"
                      [class.pi-clock]="!synergy.partner_confirmed"></i>
                  </div>
                  <div class="flex-1">
                    <div class="text-sm font-bold text-gray-900">Partner-Bestätigung</div>
                    <div class="text-xs font-medium" [class.text-emerald-600]="synergy.partner_confirmed"
                      [class.text-gray-500]="!synergy.partner_confirmed">
                      {{ synergy.partner_confirmed ? '✓ Bestätigt' : 'Ausstehend' }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Confirm Button -->
              <p-button *ngIf="!synergy.my_confirmed" label="Jetzt bestätigen" icon="pi pi-check-circle"
                styleClass="w-full mt-4" severity="success" (onClick)="onConfirm()" />
            </div>
          </div>

          <!-- Quick Actions -->
          <div
            class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gray-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-bolt text-blue-600"></i>
                Aktionen
              </h2>
            </div>
            <div class="p-6 space-y-3">
              <!-- Erfolg teilen Button (nur bei aktiven Synergien) -->
              <p-button *ngIf="synergy.status === 'active'" (onClick)="openPostModal()" label="Update teilen"
                icon="pi pi-send" styleClass="w-full " severity="secondary" />

              <p-button (onClick)="openMail()" label="Partner E-Mail" icon="pi pi-envelope" styleClass="w-full mt-4"
                severity="secondary" [outlined]="true" />

              <p-button (onClick)="openTel()" label="Partner Tel." icon="pi pi-phone" styleClass="w-full mt-4"
                severity="secondary" [outlined]="true" />
            </div>
          </div>

          <!-- Timeline Info -->
          <div
            class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gray-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-calendar text-purple-600"></i>
                Zeitlinie
              </h2>
            </div>
            <div class="p-6 space-y-3">
              <div class="flex items-center gap-3">
                <i class="pi pi-plus-circle text-gray-400"></i>
                <div class="flex-1">
                  <div class="text-xs text-gray-500">Erstellt am</div>
                  <div class="text-sm font-semibold text-gray-900">{{ synergy.created_at | date:'dd.MM.yyyy' }}</div>
                </div>
              </div>
              <div *ngIf="synergy.activated_at" class="flex items-center gap-3">
                <i class="pi pi-check-circle text-emerald-500"></i>
                <div class="flex-1">
                  <div class="text-xs text-gray-500">Aktiviert am</div>
                  <div class="text-sm font-semibold text-gray-900">{{ synergy.activated_at | date:'dd.MM.yyyy' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SUGGESTION DETAIL VIEW -->
    <div *ngIf="suggestion">
      <!-- Hero Card - CLEAN -->
      <div
        class="bg-white rounded-lg border border-gray-200 mb-6 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
        <!-- Regional Hub Badge -->
        <div *ngIf="suggestion.same_regional_hub"
          class="bg-gradient-to-r from-blue-600 to-blue-500 text-white text-center py-3 px-4 text-sm font-bold flex items-center justify-center gap-2">
          <i class="pi pi-map-marker"></i>
          <span>GLEICHER REGIONAL HUB - BESTE MATCH-CHANCE!</span>
          <i class="pi pi-star-fill text-yellow-300"></i>
        </div>

        <!-- Colored Header Bar -->
        <div class="h-1" [style.background-color]="getCategoryColor(suggestion.category)"></div>

        <div class="p-8">
          <div class="flex flex-col lg:flex-row lg:items-start gap-6">
            <!-- Category Icon -->
            <div class="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md"
              [style.background-color]="getCategoryColor(suggestion.category) + '15'">
              <i [class]="getCategoryIcon(suggestion.category)" [style.color]="getCategoryColor(suggestion.category)"
                class="text-3xl"></i>
            </div>

            <!-- Title & Meta -->
            <div class="flex-1 min-w-0">
              <h1 class="text-3xl font-bold text-gray-900 mb-3">{{ suggestion.title }}</h1>
              <div class="flex items-center gap-4 mb-4 flex-wrap">
                <p-tag [value]="suggestion.category"
                  [style]="{'background-color': getCategoryColor(suggestion.category) + '15', 'color': getCategoryColor(suggestion.category)}"
                  styleClass="text-xs font-semibold px-3 py-1.5" />
                <span class="text-sm text-gray-600 flex items-center gap-1.5">
                  <i class="pi pi-building"></i>
                  {{ suggestion.candidate_hub_name }}
                </span>
              </div>

              <!-- Location Info -->
              <div class="flex items-center gap-4 text-sm text-gray-600 mb-6 flex-wrap">
                <span class="flex items-center gap-1.5 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                  <i class="pi pi-map-marker text-blue-600"></i>
                  {{ suggestion.candidate_hub_city }}
                </span>
                <span class="flex items-center gap-1.5 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                  <i class="pi pi-directions text-emerald-600"></i>
                  {{ suggestion.distance_km }} km entfernt
                </span>
                <span class="flex items-center gap-1.5 bg-gray-50 px-3 py-2 rounded-lg border border-gray-200">
                  <i class="pi pi-tag text-purple-600"></i>
                  {{ suggestion.candidate_hub_type }}
                </span>
              </div>

              <!-- Match Score Bar - CLEAN -->
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-xs font-semibold text-gray-600 uppercase tracking-wider flex items-center gap-2">
                    <i class="pi pi-chart-line text-emerald-600"></i>
                    Match Score
                  </span>
                  <span class="text-3xl font-bold text-emerald-600">{{ suggestion.match_score }}%</span>
                </div>
                <div class="bg-gray-200 rounded-full h-3 overflow-hidden">
                  <div class="bg-emerald-500 h-full transition-all duration-500"
                    [style.width.%]="suggestion.match_score"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Grid -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <!-- Left Column -->
        <div class="lg:col-span-2 space-y-6">
          <!-- Description -->
          <div
            class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-gray-50 to-blue-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-info-circle text-blue-600"></i>
                Was euch erwartet
              </h2>
            </div>
            <div class="p-6">
              <p class="text-sm text-gray-700 leading-relaxed">{{ suggestion.description }}</p>
            </div>
          </div>

          <!-- Benefits -->
          <div
            class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-emerald-50 to-teal-50 border-b border-emerald-100 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-gift text-emerald-600"></i>
                Potenzielle Vorteile
              </h2>
            </div>
            <div class="p-6">
              <div class="space-y-4">
                <div *ngFor="let benefit of suggestion.potential_benefits"
                  class="flex items-start gap-4 p-3 rounded-lg hover:bg-emerald-50 transition-colors group">
                  <div
                    class="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-200 group-hover:scale-110 transition-all">
                    <i class="pi pi-check text-emerald-600 text-sm font-bold"></i>
                  </div>
                  <p class="text-sm text-gray-700 leading-relaxed flex-1 pt-1">{{ benefit }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- AI Reasoning -->
          <div
            class="bg-white rounded-xl border border-purple-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gradient-to-r from-purple-50 via-blue-50 to-indigo-50 border-b border-purple-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-sparkles text-purple-600"></i>
                KI-Empfehlung
                <span class="text-xs font-semibold px-2 py-1 bg-purple-100 text-purple-700 rounded-full ml-auto">
                  Automatisch generiert
                </span>
              </h2>
            </div>
            <div class="p-6">
              <p class="text-sm text-gray-700 leading-relaxed">{{ suggestion.reasoning }}</p>
            </div>
          </div>
        </div>

        <!-- Right Column - Sidebar -->
        <div class="space-y-6">
          <!-- Expected Rewards -->


          <!-- Actions -->
          <div
            class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-green-50 border-b border-green-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-bolt text-green-600"></i>
                Interesse bekunden
              </h2>
            </div>
            <div class="p-6 space-y-3">
              <p-button label="Interesse bekunden" icon="pi pi-heart" severity="info" styleClass="w-full"
                (onClick)="onExpressInterest()" [loading]="isExpressingInterest" />
              <p-button label="Zurück zur Übersicht" icon="pi pi-arrow-left" severity="secondary" [outlined]="true"
                styleClass="w-full mt-4" (onClick)="onBack()" />
            </div>
          </div>

          <!-- Match Details -->
          <div
            class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div class="bg-gray-50 border-b border-gray-200 px-6 py-4">
              <h2 class="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
                <i class="pi pi-chart-pie text-blue-600"></i>
                Match Details
              </h2>
            </div>
            <div class="p-6 space-y-3">
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="text-2xl font-bold text-emerald-600 text-center mb-1">{{ suggestion.match_score }}%</div>
                <div class="text-xs text-gray-600 text-center font-medium">Kompatibilität</div>
              </div>

              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="text-xl font-bold text-blue-600 text-center mb-1">{{ suggestion.distance_km }} km</div>
                <div class="text-xs text-gray-600 text-center font-medium">Entfernung</div>
              </div>

              <div *ngIf="suggestion.same_regional_hub" class="bg-purple-50 rounded-lg p-4 border border-purple-200">
                <div class="text-xs font-bold text-purple-600 text-center flex items-center justify-center gap-1">
                  <i class="pi pi-star-fill"></i>
                  Gleicher Regional Hub
                  <i class="pi pi-star-fill"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Synergie bestätigen" [(visible)]="showConfirmModal" [modal]="true" [closable]="true"
  [draggable]="false" [style]="{width: '600px'}" [baseZIndex]="10000">
  <div *ngIf="synergy" class="space-y-5 p-2">
    <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
      <p class="text-sm text-gray-800 leading-relaxed">
        Um die Kooperation mit <strong class="text-blue-700">{{ synergy.partner_hub.name }}</strong> zu
        aktivieren,
        gib bitte den <strong>Join-Code</strong> des Partner-Hubs ein.
      </p>
    </div>
    <div>
      <label class="block text-sm font-bold text-gray-700 mb-2">Partner Join-Code</label>
      <input type="text" pInputText placeholder="ABC-DEF-GHI" [(ngModel)]="partnerJoinCode"
        class="w-full text-center uppercase font-mono text-xl tracking-[0.3em] font-bold" [maxlength]="11">
    </div>
    <div class="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-200 rounded-lg p-4">
      <div class="flex items-start gap-3">
        <i class="pi pi-info-circle text-indigo-600 text-lg mt-0.5 flex-shrink-0"></i>
        <div class="flex-1">
          <h5 class="text-sm font-bold text-indigo-900 mb-1">Wie funktioniert das?</h5>
          <p class="text-xs text-indigo-800 leading-relaxed">
            Den Join-Code findest du oben in dieser Ansicht und kannst ihn dort direkt kopieren.
          </p>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex gap-3">
      <p-button label="Abbrechen" icon="pi pi-times" severity="secondary" [outlined]="true"
        (onClick)="closeConfirmModal()" />
      <p-button label="Bestätigen" severity="primary" icon="pi pi-check-circle" (onClick)="confirmSynergy()"
        [loading]="isConfirmingSynergy" [disabled]="!partnerJoinCode || partnerJoinCode.length < 8" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Update teilen" [(visible)]="showPostModal" [modal]="true" [closable]="true" [draggable]="false"
  [style]="{width: '700px'}" [baseZIndex]="10000">

  <div class="space-y-5 p-2">
    <div class="bg-gray-50 border-l-4 border-gray-400 p-4 rounded">
      <p class="text-sm text-gray-800 leading-relaxed">
        Teile einen Fortschritt, Meilenstein oder wichtige Information zu dieser Kooperation.
        Der Partner wird das Update in der Timeline sehen.
      </p>
    </div>

    <!-- Titel -->
    <div>
      <label class="block text-sm font-bold text-gray-700 mb-2">
        Titel <span class="text-red-500">*</span>
      </label>
      <input type="text" pInputText placeholder="z.B. Erste Bestellung erfolgreich abgeschlossen"
        [(ngModel)]="postTitle" class="w-full" [maxlength]="200">
      <small class="text-gray-500">{{ postTitle.length }}/200</small>
    </div>

    <!-- Beschreibung -->
    <div>
      <label class="block text-sm font-bold text-gray-700 mb-2">
        Beschreibung <span class="text-red-500">*</span>
      </label>
      <textarea pTextarea placeholder="Details zum Update..." [(ngModel)]="postDescription" class="w-full" [rows]="5"
        [maxlength]="1000">
      </textarea>
      <small class="text-gray-500">{{ postDescription.length }}/1000</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex gap-3">
      <p-button label="Abbrechen" icon="pi pi-times" severity="secondary" [outlined]="true"
        (onClick)="closePostModal()" />
      <p-button label="Update teilen" severity="primary" icon="pi pi-send" (onClick)="submitPost()"
        [loading]="isPostingUpdate" [disabled]="!postTitle.trim() || !postDescription.trim()" />
    </div>
  </ng-template>
</p-dialog>

